module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add_own_rider":"Add your own rider"},"id":{"add_own_rider":"Tambahkan rider kamu sendiri"}}')
  delete Component.options._Ctor
}
